'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
}); // these are taken from POM

var locales = ['x-ISO8601'].concat(['en', 'en-GB', 'en-AU', 'en-CA', 'de', 'de-CH', 'de-AT', 'fr', 'fr-CA', 'nl', 'nl-BE', 'pl', 'sk', 'it', 'es', 'es-US', 'pt', 'pt-BR', 'ja', 'zh-CN'].sort());
exports.default = locales.map(function (locale) {
  return {
    label: locale === 'x-ISO8601' ? 'ISO8601' : locale,
    value: locale
  };
});